import _ from "lodash";

// Helpers for the "Reassign activity" flow (transferring an authoring activity to another member).
// 2026-10-16 incident: the modal closed and showed success before the list refreshed, the card stayed
// on screen, and the same transfer was submitted again 58 seconds later. The backend resolved source
// and destination to the same owner and the activity deleted itself. The backend now answers
// {success:true, unchanged:true} for a repeat; the UI blocks repeat submissions, never offers the
// current owner, and waits for the refreshed list before the modal goes away.

function safeParse(text) {
	try { return JSON.parse(text); } catch (e) { return null; }
}

/** Recipient options without the current owner, blanks or duplicates. */
export function transferRecipientOptions(members, currentIdentityId) {
	const seen = new Set();
	return (Array.isArray(members) ? members : []).filter(member => {
		const value = member && _.isString(member.value) ? member.value.trim() : "";
		if (!value || value === currentIdentityId || seen.has(value)) {
			return false;
		}
		seen.add(value);
		return true;
	});
}

export function findRecipientLabel(members, identityId) {
	const match = _.find(members, member => member && member.value === identityId);
	return match && _.isString(match.label) && match.label.trim() !== "" ? match.label : "the selected member";
}

/** A transfer may be submitted once, to a real recipient other than the current owner. */
export function canSubmitTransfer({ recipient, currentIdentityId, submitting }) {
	return !submitting && _.isString(recipient) && recipient.trim() !== "" && recipient !== currentIdentityId;
}

/** Interpret the transfer response: failure, a harmless repeat (already owned), or a real transfer. */
export function describeTransferResult(body, displayName) {
	const payload = _.isString(body) ? safeParse(body) : body;
	const who = _.isString(displayName) && displayName.trim() !== "" ? displayName : "the selected member";
	if (payload && payload.success === false) {
		const message = _.isString(payload.message) && payload.message.trim() !== "" ? payload.message : "The activity could not be reassigned.";
		return { ok: false, unchanged: false, message };
	}
	if (payload && payload.unchanged === true) {
		return { ok: true, unchanged: true, message: `${who} already owns this activity. Nothing was changed.` };
	}
	return { ok: true, unchanged: false, message: `Successfully reassigned the activity to ${who}.` };
}
